import React, { FC, useState, useEffect } from 'react';
import Aipi4 from 'style/imgs/aneta-pack-items/aipink/aipi4.svg';
import { useDispatch } from 'react-redux';
import { getAllAnetaPacks } from 'actions/aneta-pack';
import { IAnetaPacks } from 'types';
import searchIcon from 'style/imgs/icons/search-icon.svg';
import Checkbox from './checkbox';
import anetaStyles from './index.module.scss';
import AnetaPackList from './AnetaPackList';
import AnetaPackSearchFilter from './AnetaPackSearchFilter';

interface AnetaPackLibraryProps {
  handleClose: () => void;
  openNext: () => void;
  handleChooseAnetapack?: (pack: IAnetaPacks) => void;
  anetaPacks: IAnetaPacks[];
}

const AnetaPackLibrary: FC<AnetaPackLibraryProps> = ({
  handleClose,
  anetaPacks,
  openNext,
  handleChooseAnetapack,
}) => {
  const dispach = useDispatch();
  const [learningSkills, setLearningSkills] = useState<string[]>([]);
  const [interests, setInterests] = useState<string[]>([]);
  const [curator, setCurator] = useState<string[]>([]);
  const [grade, setGrade] = useState<string[]>([]);

  const [anetaPacksList, setAnetaPacksList] = useState(anetaPacks);
  const [filterData, setFilterData] = useState('');

  useEffect(() => {
    setAnetaPacksList(anetaPacks);
  }, [anetaPacks]);

  const handleChangeSkills = (str: string, mode: string) => {
    if (mode === 'remove') {
      const withOutElement: string[] = [];
      learningSkills.forEach((el) => {
        if (el !== str) {
          withOutElement.push(el);
        }
      });
      setLearningSkills(withOutElement);
    } else {
      setLearningSkills([...learningSkills, str]);
    }
  };

  const handleChangeInterests = (str: string, mode: string) => {
    if (mode === 'remove') {
      const withOutElement: string[] = [];
      interests.forEach((el) => {
        if (el !== str) {
          withOutElement.push(el);
        }
      });
      setInterests(withOutElement);
    } else {
      setInterests([...interests, str]);
    }
  };

  const handleChangeCurator = (str: string, mode: string) => {
    const strType = str === 'Aneta Approved' ? 'aneta-teacher' : str;
    if (mode === 'remove') {
      const withOutElement: string[] = [];
      curator.forEach((el) => {
        if (el !== strType) {
          withOutElement.push(el);
        }
      });
      setCurator(withOutElement);
    } else {
      setCurator([...curator, strType]);
    }
  };

  const handleChangeGrade = (str: string, mode: string) => {
    let currentGrade: string[] = [];
    const Prek1 = ['Pre K', '1'];
    const grade25 = ['2', '3', '4', '5'];
    const grade68 = ['6', '7', '8'];
    const grade912 = ['9', '10', '11', '12'];
    if (str === 'Prek - 1') {
      currentGrade = Prek1;
    } else if (str === 'Grade 2-5') {
      currentGrade = grade25;
    } else if (str === 'Grade 6-8') {
      currentGrade = grade68;
    } else if (str === 'Grade 9-12') {
      currentGrade = grade912;
    }
    if (mode === 'remove') {
      const withOutElement: string[] = [];
      grade.forEach((el) => {
        if (currentGrade.indexOf(el) === -1) {
          withOutElement.push(el);
        }
      });
      setGrade(withOutElement);
    } else {
      setGrade([...grade, ...currentGrade]);
    }
  };

  const searchPost = (searchValue: string) => {
    setFilterData(searchValue);
  };

  useEffect(() => {
    dispach(getAllAnetaPacks(curator, grade, learningSkills, interests));
  }, [grade, learningSkills, curator, dispach, interests]);

  return (
    <div className={anetaStyles.dialogWrapper}>
      <div className={anetaStyles.libraryWrapper}>
        <div className={anetaStyles.testWrapperContent}>
          <div className={anetaStyles.item}>
            <div className={anetaStyles.itemHeader}>
              <div className={anetaStyles.headerElement}>
                <h2>Anetapack Library</h2>
                <p>Click on an Anetapack to view the contents</p>
              </div>
              <div className={anetaStyles.headerElement}>
                <img src={searchIcon} alt="search" />
                <AnetaPackSearchFilter searchPosts={searchPost} />
              </div>
            </div>
            <div className={anetaStyles.sepWrapper}>
              <div className={anetaStyles.lineSeparator} />
            </div>
            <div>
              <div className={anetaStyles.quantityPack}>
                {anetaPacksList.length > 0 && (
                  <div className={anetaStyles.quantityPackInner}>
                    We found <span>{anetaPacksList.length}</span> Anetapacks for
                    you
                  </div>
                )}
              </div>
              <div
                className={
                  anetaPacksList.length > 0
                    ? anetaStyles.libraryContent
                    : anetaStyles.libraryNoResults
                }
              >
                {anetaPacksList.length > 0 ? (
                  <AnetaPackList
                    posts={anetaPacksList}
                    handleClose={handleClose}
                    openNext={openNext}
                    searchValue={filterData}
                    handleChooseAnetapack={handleChooseAnetapack}
                  />
                ) : (
                  <div className={anetaStyles.NoResultsInner}>
                    <img src={Aipi4} alt="icon" />
                    <h2>No Matches Found</h2>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={anetaStyles.testWrapper}>
          <div className={anetaStyles.itemFilter}>
            <div className={anetaStyles.label}>Curator</div>
            <Checkbox
              className={anetaStyles.checkbox}
              label="Parent"
              onChange={handleChangeCurator}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Educator"
              onChange={handleChangeCurator}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Aneta Approved"
              onChange={handleChangeCurator}
            />
            <div className={anetaStyles.label}>Grade</div>
            <Checkbox
              className={anetaStyles.checkbox}
              label="Prek - 1"
              onChange={handleChangeGrade}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Grade 2-5"
              onChange={handleChangeGrade}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Grade 6-8"
              onChange={handleChangeGrade}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Grade 9-12"
              onChange={handleChangeGrade}
            />
            <div className={anetaStyles.label}>Learning Skill</div>
            <Checkbox
              className={anetaStyles.checkbox}
              label="Math"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Science"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Language Arts"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Music"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Art"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Social Studies"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Other"
              onChange={handleChangeSkills}
            />
            {/* <Checkbox
              className={anetaStyles.checkbox}
              label="Gym"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Multipurpose"
              onChange={handleChangeSkills}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Playground"
              onChange={handleChangeSkills}
            />{' '}
            <Checkbox
              className={anetaStyles.checkbox}
              label="Cafeteria"
              onChange={handleChangeSkills}
            />{' '}
            <Checkbox
              className={anetaStyles.checkbox}
              label="Makersplace"
              onChange={handleChangeSkills}
            /> */}
            <div className={anetaStyles.label}>Interests</div>
            <Checkbox
              className={anetaStyles.checkbox}
              label="Animals"
              onChange={handleChangeInterests}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Funny"
              onChange={handleChangeInterests}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Adventure"
              onChange={handleChangeInterests}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Sports"
              onChange={handleChangeInterests}
            />{' '}
            <Checkbox
              className={anetaStyles.checkbox}
              label="Fairy Tales"
              onChange={handleChangeInterests}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Space"
              onChange={handleChangeInterests}
            />{' '}
            <Checkbox
              className={anetaStyles.checkbox}
              label="Nature"
              onChange={handleChangeInterests}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Cars"
              onChange={handleChangeInterests}
            />{' '}
            <Checkbox
              className={anetaStyles.checkbox}
              label="Buildings"
              onChange={handleChangeInterests}
            />
            <Checkbox
              className={anetaStyles.checkbox}
              label="Other"
              onChange={handleChangeInterests}
            />
          </div>
        </div>
      </div>
      <button
        type="button"
        className={anetaStyles.backButton}
        onClick={handleClose}
      >
        Back
      </button>
    </div>
  );
};

export default AnetaPackLibrary;
